// extracted by mini-css-extract-plugin
export default {"main":"CollaboratorRow_main__uEiZ5"};